import { useRef, useEffect, useState } from "react";
import './NewsSection.css';
import './universal.css';
import articlesdata from '../assets/blogs/articles.json';

const articles = articlesdata ;
  


export default function NewsSection() {
  const scrollRef = useRef(null);
  const [canScrollLeft, setCanScrollLeft] = useState(false);
  const [canScrollRight, setCanScrollRight] = useState(true);

  const checkScroll = () => {
    const el = scrollRef.current;
    if (!el) return;
    setCanScrollLeft(el.scrollLeft > 10);
    setCanScrollRight(el.scrollLeft + el.clientWidth < el.scrollWidth - 10);
  };

  const scroll = (dir) => {
    const el = scrollRef.current;
    if (!el) return;
    el.scrollBy({ left: dir * 350, behavior: "smooth" });
  };

  useEffect(() => {
    const el = scrollRef.current;
    if (el) el.addEventListener("scroll", checkScroll);
    checkScroll();
    return () => el && el.removeEventListener("scroll", checkScroll);
  }, []);

  return (
    <>
      <section className="ns-section">
        <div className="container">
        <div className="ns-header">
          <div>
            <div className="ns-label">
              <span className="ns-label-dot" />
              Resources and Insights
            </div>
            <div className="ns-title-wrap">
              <h2 className="sec-title">News and articles</h2>
            </div>
          </div>
          <div className="ns-header-right">
            <button
              className="ns-arrow-btn"
              disabled={!canScrollLeft}
              onClick={() => scroll(-1)}
              aria-label="Scroll left"
            >&#8592;</button>
            <button
              className="ns-arrow-btn"
              disabled={!canScrollRight}
              onClick={() => scroll(1)}
              aria-label="Scroll right"
            >&#8594;</button>
            <button className="uni-btn">View all</button>
          </div>
        </div>

        <div className="ns-track" ref={scrollRef}>
          {articles.map((article) => (
            <div className="ns-card" key={article.id}>
              <div className="ns-img-wrap">
                <img src={article.img} alt={article.title} />

                
                {/* <div className="ns-img-tag">{article.date.split(" ").slice(-1)[0]}</div> */}
              </div>

              <div className="ns-meta">
                <p className="ns-card-date">{article.date}</p>
                <p className="ns-card-title">{article.title}</p>
                <div className="ns-card-cta">Read more &#8594;</div>
              </div>
            </div>
          ))}
        </div>
        </div>
      </section>
    </>
  );
}
